import React from 'react';
import { Typography } from '@metarouter-private/mr-mui';

const END_OF_HISTORY_MESSAGE = 'This is the complete history for this record. Audit records are retained for 90 days.';

export default function AuditLogEndOfHistory() {
  return (
    <Typography data-test-id="auditLogEndOfHistory" color="text.secondary" variant="body2">
      {END_OF_HISTORY_MESSAGE}
    </Typography>
  );
}
